/* Fichier GÉNÉRÉ — ne pas modifier à la main.
   Source : TISSUS/DAZZURO_TISSUS_FINAL_WEBDESIGNER_2026_FINAL.xlsx
   Régénérer : python scripts/tissus-taxonomie-generer.py

   Taxonomie client validée : 14 types répartis en 6 familles,
   119 tissus classés. Consommé par sections/presentation-textures.liquid,
   qui retombe sur sa table interne pour les gammes non couvertes. */
window.DAZ_TAXONOMIE = {
 "familles": [
  {
   "cle": "textures-chines",
   "libelle": "Texturés & chinés",
   "types": [
    "texture",
    "chine"
   ]
  },
  {
   "cle": "bouclettes",
   "libelle": "Bouclettes",
   "types": [
    "bouclette"
   ]
  },
  {
   "cle": "chenilles",
   "libelle": "Chenilles",
   "types": [
    "chenille"
   ]
  },
  {
   "cle": "velours",
   "libelle": "Velours",
   "types": [
    "velours",
    "velours-texture",
    "velours-chine",
    "velours-cotele",
    "velours-grosse-cote"
   ]
  },
  {
   "cle": "touchers-mats",
   "libelle": "Touchers mats",
   "types": [
    "microfibre",
    "suedine"
   ]
  },
  {
   "cle": "cuir-simili",
   "libelle": "Cuir & Simili",
   "types": [
    "simili",
    "cuir-premium",
    "cuir-prestige"
   ]
  }
 ],
 "types": [
  {
   "cle": "texture",
   "libelle": "Texturé",
   "famille": "textures-chines",
   "alias": [
    "texturé",
    "structuré",
    "tissé",
    "grosse trame",
    "relief"
   ],
   "definition": "Relief, tissage ou structure visible dominante."
  },
  {
   "cle": "chine",
   "libelle": "Chiné",
   "famille": "textures-chines",
   "alias": [
    "chiné",
    "mélangé",
    "mélange de fils",
    "heathered"
   ],
   "definition": "Mélange de fils ou de tons nettement perceptible."
  },
  {
   "cle": "bouclette",
   "libelle": "Bouclette",
   "famille": "bouclettes",
   "alias": [
    "bouclette",
    "bouclé",
    "boucle",
    "bouclettes"
   ],
   "definition": "Boucles, petits nœuds ou bouclettes visibles."
  },
  {
   "cle": "chenille",
   "libelle": "Chenille",
   "famille": "chenilles",
   "alias": [
    "chenille",
    "szenil",
    "doux"
   ],
   "definition": "Toucher doux et identité chenille immédiatement lisible."
  },
  {
   "cle": "velours",
   "libelle": "Velours",
   "famille": "velours",
   "alias": [
    "velours",
    "plush",
    "peluche"
   ],
   "definition": "Velours lisse ou moelleux sans texture dominante."
  },
  {
   "cle": "velours-texture",
   "libelle": "Velours texturé",
   "famille": "velours",
   "alias": [
    "velours structuré",
    "velours relief",
    "velours 3D"
   ],
   "definition": "Velours avec relief, grain ou structure 3D."
  },
  {
   "cle": "velours-chine",
   "libelle": "Velours chiné",
   "famille": "velours",
   "alias": [
    "velours chiné",
    "velours mélangé"
   ],
   "definition": "Velours avec mélange de tons visible."
  },
  {
   "cle": "velours-cotele",
   "libelle": "Velours côtelé",
   "famille": "velours",
   "alias": [
    "côtelé",
    "corduroy",
    "sztruks"
   ],
   "definition": "Velours à côtes régulières fines à moyennes."
  },
  {
   "cle": "velours-grosse-cote",
   "libelle": "Velours grosse côte",
   "famille": "velours",
   "alias": [
    "grosse côte",
    "gros côtelé",
    "wide corduroy"
   ],
   "definition": "Velours à côtes larges, épaisses et très affirmées."
  },
  {
   "cle": "microfibre",
   "libelle": "Microfibre",
   "famille": "touchers-mats",
   "alias": [
    "microfibre"
   ],
   "definition": "Fibres très fines, toucher dense et doux."
  },
  {
   "cle": "suedine",
   "libelle": "Suédine",
   "famille": "touchers-mats",
   "alias": [
    "suédine",
    "nubuck",
    "daim synthétique"
   ],
   "definition": "Toucher mat peau de pêche / nubuck."
  },
  {
   "cle": "simili",
   "libelle": "Simili",
   "famille": "cuir-simili",
   "alias": [
    "simili",
    "polyester",
    "textile grainé",
    "synthétique"
   ],
   "definition": "Revêtement textile 100 % polyester à surface lisse ou grainée, choisi comme alternative visuelle aux revêtements naturels."
  },
  {
   "cle": "cuir-premium",
   "libelle": "Cuir Premium",
   "famille": "cuir-simili",
   "alias": [
    "cuir",
    "cuir premium",
    "leather"
   ],
   "definition": "Cuir véritable — premier niveau de la sélection cuir Dazzuro."
  },
  {
   "cle": "cuir-prestige",
   "libelle": "Cuir Prestige",
   "famille": "cuir-simili",
   "alias": [
    "cuir",
    "cuir prestige",
    "leather"
   ],
   "definition": "Cuir véritable — niveau supérieur de la sélection cuir Dazzuro."
  }
 ],
 "tissus": {
  "bubble": {
   "nom": "Bubble",
   "type": "bouclette",
   "gamme": "I",
   "badge": "",
   "proprietes": []
  },
  "gerra": {
   "nom": "Gerra",
   "type": "bouclette",
   "gamme": "I",
   "badge": "",
   "proprietes": []
  },
  "monte": {
   "nom": "Monte",
   "type": "bouclette",
   "gamme": "I",
   "badge": "",
   "proprietes": []
  },
  "bosco": {
   "nom": "Bosco",
   "type": "chenille",
   "gamme": "I",
   "badge": "",
   "proprietes": []
  },
  "kate": {
   "nom": "Kate",
   "type": "chenille",
   "gamme": "I",
   "badge": "",
   "proprietes": []
  },
  "misterio": {
   "nom": "Misterio",
   "type": "chenille",
   "gamme": "I",
   "badge": "",
   "proprietes": []
  },
  "moly": {
   "nom": "Moly",
   "type": "chenille",
   "gamme": "I",
   "badge": "",
   "proprietes": []
  },
  "vibe": {
   "nom": "Vibe",
   "type": "chenille",
   "gamme": "I",
   "badge": "",
   "proprietes": []
  },
  "gemma": {
   "nom": "Gemma",
   "type": "chine",
   "gamme": "I",
   "badge": "",
   "proprietes": [
    "Protection liquide"
   ]
  },
  "mossa": {
   "nom": "Mossa",
   "type": "chine",
   "gamme": "I",
   "badge": "",
   "proprietes": []
  },
  "vera": {
   "nom": "Vera",
   "type": "chine",
   "gamme": "I",
   "badge": "",
   "proprietes": [
    "Easy Clean",
    "Protection liquide"
   ]
  },
  "enjoy": {
   "nom": "Enjoy",
   "type": "microfibre",
   "gamme": "I",
   "badge": "",
   "proprietes": []
  },
  "nube": {
   "nom": "Nube",
   "type": "simili",
   "gamme": "I",
   "badge": "100 % polyester",
   "proprietes": []
  },
  "zaria": {
   "nom": "Zaria",
   "type": "suedine",
   "gamme": "I",
   "badge": "",
   "proprietes": []
  },
  "diosa": {
   "nom": "Diosa",
   "type": "texture",
   "gamme": "I",
   "badge": "",
   "proprietes": [
    "Easy Clean"
   ]
  },
  "enzo": {
   "nom": "Enzo",
   "type": "texture",
   "gamme": "I",
   "badge": "",
   "proprietes": []
  },
  "evolution": {
   "nom": "Evolution",
   "type": "texture",
   "gamme": "I",
   "badge": "",
   "proprietes": []
  },
  "fusion": {
   "nom": "Fusion",
   "type": "texture",
   "gamme": "I",
   "badge": "",
   "proprietes": []
  },
  "hygge": {
   "nom": "Hygge",
   "type": "texture",
   "gamme": "I",
   "badge": "",
   "proprietes": []
  },
  "malmo": {
   "nom": "Malmo",
   "type": "texture",
   "gamme": "I",
   "badge": "",
   "proprietes": []
  },
  "neve": {
   "nom": "Neve",
   "type": "texture",
   "gamme": "I",
   "badge": "",
   "proprietes": []
  },
  "rebel": {
   "nom": "Rebel",
   "type": "texture",
   "gamme": "I",
   "badge": "",
   "proprietes": []
  },
  "rino": {
   "nom": "Rino",
   "type": "texture",
   "gamme": "I",
   "badge": "",
   "proprietes": []
  },
  "magic velvet (2217, 2274, 2295)": {
   "nom": "Magic Velvet (2217, 2274, 2295)",
   "type": "velours",
   "gamme": "I",
   "badge": "",
   "proprietes": []
  },
  "manila": {
   "nom": "Manila",
   "type": "velours",
   "gamme": "I",
   "badge": "",
   "proprietes": []
  },
  "paros": {
   "nom": "Paros",
   "type": "velours",
   "gamme": "I",
   "badge": "",
   "proprietes": []
  },
  "riviera": {
   "nom": "Riviera",
   "type": "velours",
   "gamme": "I",
   "badge": "",
   "proprietes": []
  },
  "seal": {
   "nom": "Seal",
   "type": "velours",
   "gamme": "I",
   "badge": "",
   "proprietes": [
    "Protection liquide"
   ]
  },
  "serta": {
   "nom": "Serta",
   "type": "velours",
   "gamme": "I",
   "badge": "",
   "proprietes": []
  },
  "solo": {
   "nom": "Solo",
   "type": "velours",
   "gamme": "I",
   "badge": "",
   "proprietes": [
    "Easy Clean",
    "Protection liquide"
   ]
  },
  "vena": {
   "nom": "Vena",
   "type": "velours",
   "gamme": "I",
   "badge": "",
   "proprietes": []
  },
  "vogue": {
   "nom": "Vogue",
   "type": "velours",
   "gamme": "I",
   "badge": "",
   "proprietes": []
  },
  "wave": {
   "nom": "Wave",
   "type": "velours",
   "gamme": "I",
   "badge": "",
   "proprietes": []
  },
  "zetta": {
   "nom": "Zetta",
   "type": "velours",
   "gamme": "I",
   "badge": "",
   "proprietes": []
  },
  "anafi": {
   "nom": "Anafi",
   "type": "velours-grosse-cote",
   "gamme": "II",
   "badge": "",
   "proprietes": [
    "Easy Clean"
   ]
  },
  "blur": {
   "nom": "Blur",
   "type": "velours-texture",
   "gamme": "I",
   "badge": "",
   "proprietes": []
  },
  "soro": {
   "nom": "Soro",
   "type": "velours-texture",
   "gamme": "I",
   "badge": "",
   "proprietes": []
  },
  "zoom": {
   "nom": "Zoom",
   "type": "velours-texture",
   "gamme": "I",
   "badge": "",
   "proprietes": []
  },
  "anthology": {
   "nom": "Anthology",
   "type": "bouclette",
   "gamme": "II",
   "badge": "",
   "proprietes": []
  },
  "quelle": {
   "nom": "Quelle",
   "type": "bouclette",
   "gamme": "II",
   "badge": "",
   "proprietes": []
  },
  "aphrodite": {
   "nom": "Aphrodite",
   "type": "chenille",
   "gamme": "II",
   "badge": "",
   "proprietes": []
  },
  "casa": {
   "nom": "Casa",
   "type": "chenille",
   "gamme": "II",
   "badge": "",
   "proprietes": []
  },
  "loris": {
   "nom": "Loris",
   "type": "chenille",
   "gamme": "II",
   "badge": "",
   "proprietes": [
    "Natural Look"
   ]
  },
  "over the horizon": {
   "nom": "Over the Horizon",
   "type": "chenille",
   "gamme": "II",
   "badge": "",
   "proprietes": []
  },
  "retro bliss": {
   "nom": "Retro Bliss",
   "type": "chenille",
   "gamme": "II",
   "badge": "",
   "proprietes": []
  },
  "rosario": {
   "nom": "Rosario",
   "type": "chenille",
   "gamme": "II",
   "badge": "",
   "proprietes": []
  },
  "sole": {
   "nom": "Sole",
   "type": "chenille",
   "gamme": "II",
   "badge": "",
   "proprietes": [
    "Easy Clean",
    "Protection liquide"
   ]
  },
  "wind": {
   "nom": "Wind",
   "type": "chenille",
   "gamme": "II",
   "badge": "",
   "proprietes": []
  },
  "massimo": {
   "nom": "Massimo",
   "type": "chine",
   "gamme": "II",
   "badge": "",
   "proprietes": []
  },
  "logan": {
   "nom": "Logan",
   "type": "microfibre",
   "gamme": "II",
   "badge": "",
   "proprietes": []
  },
  "mindelo": {
   "nom": "Mindelo",
   "type": "suedine",
   "gamme": "II",
   "badge": "",
   "proprietes": [
    "Protection liquide",
    "Good for Babies",
    "Good for Planet"
   ]
  },
  "aragon": {
   "nom": "Aragon",
   "type": "texture",
   "gamme": "II",
   "badge": "",
   "proprietes": []
  },
  "aston": {
   "nom": "Aston",
   "type": "texture",
   "gamme": "II",
   "badge": "",
   "proprietes": []
  },
  "curio": {
   "nom": "Curio",
   "type": "texture",
   "gamme": "II",
   "badge": "",
   "proprietes": []
  },
  "legacy": {
   "nom": "Legacy",
   "type": "chenille",
   "gamme": "II",
   "badge": "",
   "proprietes": []
  },
  "matana": {
   "nom": "Matana",
   "type": "texture",
   "gamme": "II",
   "badge": "",
   "proprietes": []
  },
  "megan": {
   "nom": "Megan",
   "type": "texture",
   "gamme": "II",
   "badge": "",
   "proprietes": []
  },
  "modesto": {
   "nom": "Modesto",
   "type": "texture",
   "gamme": "II",
   "badge": "",
   "proprietes": []
  },
  "noma": {
   "nom": "Noma",
   "type": "texture",
   "gamme": "II",
   "badge": "",
   "proprietes": []
  },
  "polaris": {
   "nom": "Polaris",
   "type": "texture",
   "gamme": "II",
   "badge": "",
   "proprietes": []
  },
  "rimo": {
   "nom": "Rimo",
   "type": "texture",
   "gamme": "II",
   "badge": "",
   "proprietes": []
  },
  "castel": {
   "nom": "Castel",
   "type": "velours",
   "gamme": "II",
   "badge": "",
   "proprietes": [
    "Easy Clean"
   ]
  },
  "cloud": {
   "nom": "Cloud",
   "type": "velours",
   "gamme": "II",
   "badge": "",
   "proprietes": [
    "Easy Clean",
    "Protection liquide"
   ]
  },
  "fantasy velvet": {
   "nom": "Fantasy Velvet",
   "type": "velours",
   "gamme": "II",
   "badge": "",
   "proprietes": []
  },
  "kronos": {
   "nom": "Kronos",
   "type": "velours",
   "gamme": "II",
   "badge": "",
   "proprietes": []
  },
  "monolith": {
   "nom": "Monolith",
   "type": "velours",
   "gamme": "II",
   "badge": "",
   "proprietes": [
    "Protection liquide"
   ]
  },
  "element": {
   "nom": "Element",
   "type": "velours-chine",
   "gamme": "II",
   "badge": "",
   "proprietes": [
    "Protection liquide",
    "Pet Friendly",
    "Non Flammable",
    "Good for Babies",
    "Good for Planet"
   ]
  },
  "fancy": {
   "nom": "Fancy",
   "type": "velours-chine",
   "gamme": "II",
   "badge": "",
   "proprietes": []
  },
  "hit sztruks": {
   "nom": "Hit Sztruks",
   "type": "velours-cotele",
   "gamme": "II",
   "badge": "",
   "proprietes": []
  },
  "run again": {
   "nom": "Run Again",
   "type": "velours-cotele",
   "gamme": "II",
   "badge": "",
   "proprietes": []
  },
  "ambience": {
   "nom": "Ambience",
   "type": "velours-grosse-cote",
   "gamme": "II",
   "badge": "",
   "proprietes": []
  },
  "lincoln": {
   "nom": "Lincoln",
   "type": "velours-cotele",
   "gamme": "II",
   "badge": "",
   "proprietes": []
  },
  "poso": {
   "nom": "Poso",
   "type": "velours-cotele",
   "gamme": "II",
   "badge": "",
   "proprietes": []
  },
  "forever": {
   "nom": "Forever",
   "type": "velours-texture",
   "gamme": "II",
   "badge": "",
   "proprietes": []
  },
  "salvador": {
   "nom": "Salvador",
   "type": "velours-texture",
   "gamme": "II",
   "badge": "",
   "proprietes": [
    "Protection liquide"
   ]
  },
  "torre": {
   "nom": "Torre",
   "type": "velours-texture",
   "gamme": "II",
   "badge": "",
   "proprietes": [
    "Protection liquide",
    "Non Flammable"
   ]
  },
  "abriamo": {
   "nom": "Abriamo",
   "type": "bouclette",
   "gamme": "III",
   "badge": "",
   "proprietes": []
  },
  "catch me": {
   "nom": "Catch Me",
   "type": "bouclette",
   "gamme": "III",
   "badge": "Premium",
   "proprietes": [
    "Good for Babies",
    "Good for Planet"
   ]
  },
  "legend": {
   "nom": "Legend",
   "type": "bouclette",
   "gamme": "III",
   "badge": "",
   "proprietes": []
  },
  "manza": {
   "nom": "Manza",
   "type": "bouclette",
   "gamme": "III",
   "badge": "",
   "proprietes": []
  },
  "now or never": {
   "nom": "Now or Never",
   "type": "bouclette",
   "gamme": "III",
   "badge": "",
   "proprietes": [
    "Polyester recyclé"
   ]
  },
  "eclipse": {
   "nom": "Eclipse",
   "type": "chenille",
   "gamme": "III",
   "badge": "",
   "proprietes": []
  },
  "perfect harmony": {
   "nom": "Perfect Harmony",
   "type": "chenille",
   "gamme": "III",
   "badge": "",
   "proprietes": []
  },
  "tia": {
   "nom": "Tia",
   "type": "chenille",
   "gamme": "III",
   "badge": "",
   "proprietes": [
    "Easy Clean",
    "Protection liquide"
   ]
  },
  "wicker": {
   "nom": "Wicker",
   "type": "chenille",
   "gamme": "III",
   "badge": "",
   "proprietes": []
  },
  "provoke me": {
   "nom": "Provoke Me",
   "type": "chine",
   "gamme": "III",
   "badge": "",
   "proprietes": []
  },
  "gavin": {
   "nom": "Gavin",
   "type": "microfibre",
   "gamme": "III",
   "badge": "",
   "proprietes": []
  },
  "bison": {
   "nom": "Bison",
   "type": "simili",
   "gamme": "III",
   "badge": "100 % polyester",
   "proprietes": []
  },
  "texas": {
   "nom": "Texas",
   "type": "simili",
   "gamme": "III",
   "badge": "100 % polyester",
   "proprietes": []
  },
  "bernardo": {
   "nom": "Bernardo",
   "type": "texture",
   "gamme": "III",
   "badge": "",
   "proprietes": []
  },
  "coco": {
   "nom": "Coco",
   "type": "texture",
   "gamme": "III",
   "badge": "",
   "proprietes": []
  },
  "corbett": {
   "nom": "Corbett",
   "type": "texture",
   "gamme": "III",
   "badge": "",
   "proprietes": [
    "Easy Clean",
    "Protection liquide"
   ]
  },
  "cremona": {
   "nom": "Cremona",
   "type": "texture",
   "gamme": "III",
   "badge": "",
   "proprietes": []
  },
  "enjoy me": {
   "nom": "Enjoy Me",
   "type": "texture",
   "gamme": "III",
   "badge": "",
   "proprietes": [
    "Non Flammable"
   ]
  },
  "memphis": {
   "nom": "Memphis",
   "type": "texture",
   "gamme": "III",
   "badge": "",
   "proprietes": []
  },
  "puente": {
   "nom": "Puente",
   "type": "texture",
   "gamme": "III",
   "badge": "Chiné",
   "proprietes": []
  },
  "rinaldi": {
   "nom": "Rinaldi",
   "type": "texture",
   "gamme": "III",
   "badge": "",
   "proprietes": []
  },
  "sereno": {
   "nom": "Sereno",
   "type": "texture",
   "gamme": "III",
   "badge": "",
   "proprietes": []
  },
  "chill me": {
   "nom": "Chill Me",
   "type": "velours",
   "gamme": "III",
   "badge": "",
   "proprietes": []
  },
  "letto": {
   "nom": "Letto",
   "type": "velours",
   "gamme": "III",
   "badge": "",
   "proprietes": [
    "Easy Clean",
    "Pet Friendly"
   ]
  },
  "solar": {
   "nom": "Solar",
   "type": "velours",
   "gamme": "III",
   "badge": "",
   "proprietes": [
    "Easy Clean",
    "Pet Friendly"
   ]
  },
  "supervio": {
   "nom": "Supervio",
   "type": "velours",
   "gamme": "III",
   "badge": "",
   "proprietes": []
  },
  "touch me": {
   "nom": "Touch Me",
   "type": "velours",
   "gamme": "III",
   "badge": "",
   "proprietes": [
    "Non Flammable",
    "Good for Babies",
    "Good for Planet",
    "REACH"
   ]
  },
  "mega": {
   "nom": "Mega",
   "type": "velours-grosse-cote",
   "gamme": "III",
   "badge": "",
   "proprietes": []
  },
  "tilia": {
   "nom": "Tilia",
   "type": "velours-grosse-cote",
   "gamme": "III",
   "badge": "",
   "proprietes": []
  },
  "golden": {
   "nom": "Golden",
   "type": "velours-texture",
   "gamme": "III",
   "badge": "",
   "proprietes": []
  },
  "imo": {
   "nom": "Imo",
   "type": "velours-texture",
   "gamme": "III",
   "badge": "",
   "proprietes": []
  },
  "sorriso": {
   "nom": "Sorriso",
   "type": "velours-texture",
   "gamme": "III",
   "badge": "",
   "proprietes": []
  },
  "ditra new": {
   "nom": "Ditra New",
   "type": "chenille",
   "gamme": "IV",
   "badge": "",
   "proprietes": []
  },
  "desire me": {
   "nom": "Desire Me",
   "type": "texture",
   "gamme": "IV",
   "badge": "",
   "proprietes": []
  },
  "nido": {
   "nom": "Nido",
   "type": "texture",
   "gamme": "IV",
   "badge": "",
   "proprietes": []
  },
  "furbo": {
   "nom": "Furbo",
   "type": "velours-grosse-cote",
   "gamme": "IV",
   "badge": "",
   "proprietes": []
  },
  "cambon": {
   "nom": "Cambon",
   "type": "chenille",
   "gamme": "V",
   "badge": "",
   "proprietes": []
  },
  "raptor": {
   "nom": "Raptor",
   "type": "texture",
   "gamme": "V",
   "badge": "",
   "proprietes": []
  },
  "virtu": {
   "nom": "Virtu",
   "type": "velours",
   "gamme": "V",
   "badge": "",
   "proprietes": [
    "Pet Friendly"
   ]
  },
  "tisso": {
   "nom": "Tisso",
   "type": "bouclette",
   "gamme": "VI",
   "badge": "",
   "proprietes": []
  },
  "toledo": {
   "nom": "Toledo",
   "type": "cuir-premium",
   "gamme": "VI",
   "badge": "",
   "proprietes": []
  },
  "granada": {
   "nom": "Granada",
   "type": "cuir-prestige",
   "gamme": "VII",
   "badge": "",
   "proprietes": []
  },
  "massif": {
   "nom": "Massif",
   "type": "cuir-prestige",
   "gamme": "VII",
   "badge": "",
   "proprietes": []
  }
 }
};
